import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('calendar', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 5C5.22386 5 5 4.80412 5 4.5625V3.5H3C2.72386 3.5 2.5 3.72386 2.5 4V6H13.5V4C13.5 3.72386 13.2761 3.5 13 3.5H10.875V4.5625C10.875 4.80412 10.6791 5 10.4375 5C10.1959 5 10 4.80412 10 4.5625V3.5H6V4.5625C6 4.80412 5.77614 5 5.5 5ZM10 2.5H6V1.9375C6 1.69588 5.77614 1.5 5.5 1.5C5.22386 1.5 5 1.69588 5 1.9375V2.5H3C2.17157 2.5 1.5 3.17157 1.5 4V13C1.5 13.8284 2.17157 14.5 3 14.5H13C13.8284 14.5 14.5 13.8284 14.5 13V4C14.5 3.17157 13.8284 2.5 13 2.5H10.875V1.9375C10.875 1.69588 10.6791 1.5 10.4375 1.5C10.1959 1.5 10 1.69588 10 1.9375V2.5ZM2.5 7V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V7H2.5Z",
    fill: props.colors[0]
  }));
});